/**
 * O que todo mapa do bHunter precisa saber antes de desenhar: a chave, o Map ID e o carregador.
 *
 * Existia como constante repetida em cada componente de mapa, e o `setOptions` — que vale para a
 * PÁGINA inteira e tem de vir antes de qualquer `importLibrary` — tinha um guarda próprio em cada
 * arquivo. Dois guardas independentes para uma coisa global é uma corrida esperando acontecer:
 * basta o segundo mapa montar primeiro com outros parâmetros.
 *
 * ## Map ID
 *
 * Os marcadores modernos (`AdvancedMarkerElement`) só renderizam num mapa com Map ID — é o
 * identificador de estilo que se cria no console do Google Cloud, de graça. Sem ele o mapa
 * aparece e os marcadores não, que é o pior dos mundos: a tela parece funcionar e mente.
 *
 * Sem `VITE_GOOGLE_MAPS_MAP_ID` caímos no `DEMO_MAP_ID`, que o Google publica exatamente para
 * isto e diz para não usar em produção. É rede de segurança, não destino: `mapIdEhDemo` deixa a
 * tela cobrar a configuração em vez de esconder a pendência.
 */
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

export const CHAVE_MAPS = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined;

const MAP_ID_CONFIGURADO = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined;

/** O Map ID a usar. Nunca vazio: sem marcador moderno o mapa não conta o que precisa contar. */
export const MAP_ID = MAP_ID_CONFIGURADO || 'DEMO_MAP_ID';

/** Verdadeiro quando estamos no Map ID de demonstração — a tela avisa em vez de fingir. */
export const mapIdEhDemo = !MAP_ID_CONFIGURADO;

let opcoesDefinidas = false;

/** `setOptions` vale para a página inteira; quem chamar primeiro define, o resto não repete. */
export function garantirOpcoes(apiKey: string): void {
  if (opcoesDefinidas) return;
  setOptions({ key: apiKey, v: 'weekly' });
  opcoesDefinidas = true;
}

export { importLibrary };
